app.positions = [
  {
    order: 0,
    rev: false,
    left: -59,
    // top: 227,
    defaultTop: [ 0.24, 0.14 ],
    parent: 'main',
    scrSync: false,
  },{
    order: 1,
    rev: true,
    left: 258,
    // top: 450,
    defaultTop: [ 0.30, 0.21 ],
    parent: 'main',
    scrSync: false,
  },{
    order: 2,
    rev: false,
    left: -228,
    // top: 493,
    defaultTop: [ 0.35, 0.32 ],
    parent: 'main',
    scrSync: false,
  },{
    order: 3,
    rev: true,
    left: 60,
    // top: 543,
    defaultTop: [ 0.45, 0.43 ],
    parent: 'main',
    scrSync: false,
  },{
    order: 4,
    rev: false,
    left: -225,
    // top: 910,
    defaultTop: 0.75,
    parent: 'main',
    scrSync: false,
  },{
    order: 5,
    rev: true,
    left: 100,
    defaultTop: [ 0.87, 0.85 ],
    parent: 'main',
    scrSync: false,
  },{
    order: 6,
    rev: true,
    left: 238,
    // top: 15,
    defaultTop: 0.90,
    parent: 'main',
    scrSync: false,
    tapus: true
  },{
    order: 7,
    rev: false,
    left: -61,
    // top: 1090,
    defaultTop: 0.96,
    parent: 'main',
    scrSync: false,
  },{
    order: 8,
    rev: false,
    left: -62,
    top: -100,
    parent: 'newsIndex',
    scrSync: true,
  },{
    order: 9,
    rev: false,
    left: -190,
    top: -43,
    parent: 'newsIndex',
    scrSync: true,
  },{
    order: 10,
    rev: true,
    left: 224,
    top: 90,
    parent: 'newsIndex',
    scrSync: true,
  },{
    order: 11,
    rev: false,
    left: -250,
    top: 343,
    parent: 'newsIndex',
    scrSync: true,
  },{
    order: 12,
    rev: false,
    left: -55,
    top: -100,
    parent: 'product',
    scrSync: true,
  },{
    order: 13,
    rev: false,
    left: -221,
    top: 132,
    parent: 'product',
    scrSync: true,
  },{
    order: 14,
    rev: true,
    left: 189,
    top: 323,
    // defaultTop: 0.26,
    parent: 'product',
    scrSync: true,
  },{
    order: 15,
    rev: true,
    left: 211,
    top: 1430,
    parent: 'product',
    scrSync: true,
  },{
    order: 16,
    rev: false,
    left: -240,
    top: -231,
    parent: 'recruit',
    scrSync: true,
  },{
    order: 17,
    rev: true,
    left: 152,
    top: 34,
    parent: 'recruit',
    scrSync: true,
  },{
    order: 18,
    rev: true,
    left: 207,
    top: 251,
    parent: 'recruit',
    scrSync: true,
  },{
    order: 19,
    rev: false,
    left: -255,
    top: 336,
    parent: 'recruit',
    scrSync: true,
  },{
    order: 20,
    rev: false,
    left: -255,
    top: 1740,
    parent: 'recruit',
    scrSync: true,
  },{
    order: 21,
    rev: true,
    left: 249,
    top: 1870,
    parent: 'recruit',
    scrSync: true,
  },{
    order: 22,
    rev: false,
    left: -217,
    top: 2200,
    parent: 'recruit',
    scrSync: true,
  },{
    order: 23,
    rev: false,
    left: -79,
    top: -184,
    parent: 'about',
    scrSync: true,
  },{
    order: 24,
    rev: true,
    left: 158,
    top: -50,
    parent: 'about',
    scrSync: true,
  },{
    order: 25,
    rev: false,
    left: -227,
    top: 90,
    parent: 'about',
    scrSync: true,
  },{
    order: 26,
    rev: true,
    left: 218,
    top: 481,
    parent: 'about',
    scrSync: true,
  },{
    order: 27,
    rev: true,
    left: 217,
    top: 2040,
    parent: 'about',
    scrSync: true,
  },{
    order: 28,
    rev: false,
    left: -120,
    top: -70,
    parent: 'contact',
    scrSync: true,
  },{
    order: 29,
    rev: true,
    left: 140,
    top: 70,
    parent: 'contact',
    scrSync: true,
  },{
    order: 30,
    rev: false,
    left: -200,
    top: 200,
    parent: 'contact',
    scrSync: true,
  },{
    order: 31,
    rev: true,
    left: 125,
    top: 1087,
    parent: 'contact',
    scrSync: true,
  },{
    order: 32,
    rev: false,
    left: -129,
    top: 1122,
    parent: 'contact',
    scrSync: true,
  },{
    order: 33,
    rev: false,
    left: -206,
    top: 548,
    parent: 'footer',
    scrSync: true,
    defaultPos: 1,
    tapus: true
  },{
    order: 34,
    rev: true,
    left: 198,
    top: 630,
    parent: 'footer',
    scrSync: true,
    defaultPos: 1,
  }
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/_positions.js
// module id = 3
// module chunks = 0